import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef, useState } from 'react';
import { colors } from '../../../../../../../../colorVars';
import { addSavedAlertTradePlanConfiguration } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/alerts/addSavedAlertTradePlanConfiguration';
import { removeSavedAlertTradePlanConfiguration } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/alerts/removeSavedAlertTradePlanConfiguration';
import { updateSavedAlertTradePlanConfiguration } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/alerts/updateSavedAlertTradePlanConfiguration';
import { useAlertsStore } from '../../../../../../../../stores/websocketStore/_alertsStore';
import { DeleteButton } from '../../../../../../../atomic/buttons/deleteButton/DeleteButton';
import { LoadButton } from '../../../../../../../atomic/buttons/loadButton/LoadButton';
import { SaveButton } from '../../../../../../../atomic/buttons/saveButton/SaveButton';
import { BoxInput } from '../../../../../../../atomic/inputs/boxInput/BoxInput';
import { Body2, Body3, fontSizes } from '../../../../../../../atomic/text/Text';
import OverwriteModal from '../../../../../../../forms/tradeplans/templateFunctions/overwriteModal/OverwriteModal';
import { useAlertFormStore } from '../../alertFormClass';
import style from './UtilitySection.module.css';

export const UtilitySection = observer(() => {
  const [saveTemplateName, setSaveTemplateName] = useState('');
  const [selectedTemplate, setSelectedTemplate] = useState('default');
  const [openOverwriteModal, setOpenOverwriteModal] = useState(false);
  const alertStore = useAlertsStore();
  const configurationNames = alertStore.savedConfigurationList;
  const configurations = alertStore.savedAlertTradePlanConfigurations;
  const [message, setMessage] = useState({
    content: '',
    type: 'success',
  });

  const form = useAlertFormStore();
  const data = form.dataObj;
  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <div className={`${style.container} noDragTag`}>
      <Body2 color={colors.lightGrey} fontWeight={700}>
        Template
      </Body2>
      <div className={style.body}>
        <div className={style.saveInputAndButton}>
          <BoxInput
            height="26px"
            width="125px"
            value={saveTemplateName}
            setValue={(value) => setSaveTemplateName(value)}
            fontSize={fontSizes.body3}
            backgroundColor="inherit"
          />
          <SaveButton
            size={24}
            backgroundColor={colors.blue}
            clickHandler={() => {
              if (saveTemplateName === '') {
                setMessage({
                  content: 'Please give the template a name.',
                  type: 'error',
                });
                const timeout = setTimeout(() => {
                  setMessage({
                    content: '',
                    type: 'success',
                  });
                }, 2000);
                timeoutRef.current = timeout;

              } else if (configurationNames.includes(saveTemplateName)) {
                setOpenOverwriteModal(true);
              } else {
                addSavedAlertTradePlanConfiguration({
                  configurationName: saveTemplateName,
                  json: data,
                });
                setMessage({
                  content: 'Template saved.',
                  type: 'success',
                });
                const timeout = setTimeout(() => {
                  setMessage({
                    content: '',
                    type: 'success',
                  });
                }, 2000);
                timeoutRef.current = timeout;

              }
            }}
          />
        </div>
        <div className={style.loadDropdownAndButton}>
          <select
            className={style.select}
            value={selectedTemplate}
            onChange={({ target }) => setSelectedTemplate(target.value)}
          >
            <option value="default" key="default">
              Select a template...
            </option>
            {configurationNames.map((name) => (
              <option value={name} key={configurations[name].key}>
                {name}
              </option>
            ))}
          </select>
          <LoadButton
            size={24}
            backgroundColor={colors.green}
            clickHandler={() => {
              if (selectedTemplate === 'default') {
                setMessage({
                  content: 'Select a template to load.',
                  type: 'error',
                });
                const timeout = setTimeout(() => {
                  setMessage({
                    content: '',
                    type: 'success',
                  });
                }, 2000);
                timeoutRef.current = timeout;
              } else {
                form.setFormToTemplate(configurations[selectedTemplate].json);
              }
            }}
          />
          <DeleteButton
            size={24}
            backgroundColor={colors.red}
            clickHandler={() => {
              if (selectedTemplate === 'default') {
                setMessage({
                  content: 'Select a template to delete.',
                  type: 'error',
                });
                const timeout = setTimeout(() => {
                  setMessage({
                    content: '',
                    type: 'success',
                  });
                }, 2000);
                timeoutRef.current = timeout;
              } else {
                removeSavedAlertTradePlanConfiguration({
                  configurationName:
                    configurations[selectedTemplate].configurationName,
                  key: configurations[selectedTemplate].key,
                });
              }
            }}
          />
        </div>
        <div className={style.errorMessageSection}>
          <Body3 color={message.type === 'success' ? colors.green : colors.red}>
            {message.content}
          </Body3>
        </div>
      </div>
      <OverwriteModal
        configName={saveTemplateName}
        open={openOverwriteModal}
        handleClose={() => setOpenOverwriteModal(false)}
        updateConfig={() => {
          updateSavedAlertTradePlanConfiguration({
            configurationName: saveTemplateName,
            key: configurations[saveTemplateName].key,
            json: data,
          });
          setOpenOverwriteModal(false);
        }}
      />
    </div>
  );
});
